module.exports = __webpack_public_path__ + "img/logo.e1e7a24b.png";